import type { ReactNode } from 'react';

export const symbol_safety_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M616-345q57-57 57-136t-57-136q-57-57-136-57t-136 57q-57 57-57 136t57 136q57 57 136 57t136-57ZM497-483l69 63q6 5 6.5 13t-5.5 14q-5 5-12.5 5.5T541-392l-76-70q-5-5-7.5-10.5T455-484v-102q0-9 6-15t15-6q9 0 15 6t6 15v103ZM470.5-85q-4.5-1-9.5-3-139-47-220-168.5T160-523v-196q0-19 11-34.5t28-22.5l260-97q11-4 21-4t21 4l260 97q17 7 28 22.5t11 34.5v196q0 145-81 266.5T499-88q-5 2-9.5 3t-9.5 1q-5 0-9.5-1Zm9.5-58q115-38 187.5-143.5T740-523v-196l-260-98-260 98v196q0 131 72.5 236.5T480-143Zm0-337Z"
		/>
	</svg>
);
